export enum ChargeTo {
  CLIENT = 'C',
  DEALER = 'D',
  LENDER = 'L',
}
